<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <!-- <label class="control-label col-sm-3">{{ 'Comment' | translate }}:</label> -->
    <!-- <div class="col-sm-9"> -->
        <textarea required style="border-radius: 1rem !important; resize: none;" rows="5" placeholder="{{ 'Write a comment' | translate }}..." class="form-control" [(ngModel)]="editticket.comment" name="comment">
        </textarea>
    <!-- </div> -->
  </div>
  <div class="footer-btns">
      <button type="submit" class="btn primary-btn btn primary-btn-fw m-0" [disabled]="form.form.invalid || form.form.pending || isDisabled">
        {{ 'Comment' | translate }}
      </button>
      <!-- <button type="button" class="btn secundary-btn" (click)="onCancel()">{{ 'Cancel' | translate }}</button> -->
  </div>
</form>
